import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import { endpoints } from '@/constants/urls';

const CustomDatasetActionImage = ({ description, label }) => {
  const [image, setImage] = useState(`${endpoints.API_IMAGES}${label.toLowerCase()}.svg`);

  return image ? (
    <img
      src={image}
      className="aridhia-custom-action-icon icon image"
      alt={description}
      onError={() => setImage(null)}
    />
  ) : (
    <Icon
      name="external alternate"
      className="primary"
      title={description}
    />
  );
};

export default CustomDatasetActionImage;
